import React, { ChangeEvent, Key, useEffect, useState } from 'react'
import './Users.scss'
import { Link, useNavigate } from 'react-router-dom'
import { HorizontalLoader, ImageSrc, ModalWrapper, Pagination } from '../../../../../Components'
import AddUser from '../../../Components/User/AddUser/AddUser'
import { EmployeeType } from '../../../../../Models'
import { Logger } from '../../../../../Helpers/Logger'
import SearchInput from '../../../../../Components/SearchInput/SearchInput'
import {
  CsvDownloader,
  TableSerialNumber,
  checkSearchInputType,
  handleError,
} from '../../../../../Helpers'
import { EditUserPlan } from '../../../Components'
import { locationService } from '../../../../../Services/locationService'
import { ShowTGAlert } from '../../../../../Helpers/ShowTGAlert'
import { countryType } from 'Pages/Frontend/Components/User/EditUserPlan/EditUserPlan'
import employeeService from '../../../../../Services/employeeService'
import Swal from 'sweetalert2'
import { EmployeeSingleType } from 'Models/employeeType'
import ExportSvg from 'Components/Svgs/ExportSvg'
import { FilterSvg, PlusSignWhiteSvg } from 'Components/Svgs'
import Papa from 'papaparse'
import exportService from 'Services/exportService'
// import MultiPLPModal from '../../../Components/User/MultiPLPModal/MultiPLPModal'

interface IUser {
  id: string
  firstName: string
  lastName: string
}

const Users = () => {
  const [showModal, setShowModal] = useState(false)
  const [user, setUser] = useState<IUser>({
    id: '',
    firstName: '',
    lastName: '',
  })

  const { showAlert } = ShowTGAlert()

  const toggleModal = () => {
    setShowModal((prevState) => !prevState)
  }

  const [showEditModal, setShowEditModal] = useState(false)

  const toggleEditModal = () => {
    setShowEditModal((prevState) => !prevState)
  }

  const [showOffBoardingModal, setShowOffBoardingModal] = useState(false)

  const toggleOffBoardingModal = () => {
    setShowOffBoardingModal((prevState) => !prevState)
  }

  const [showTerminationModal, setShowTerminationModal] = useState(false)

  const toggleTerminationModal = () => {
    setShowTerminationModal((prevState) => !prevState)
  }

  const [showMultiPLPModal, setShowMultiPLPModal] = useState(false)

  const toggleMultiPLPModal = () => {
    setShowMultiPLPModal((prevState) => !prevState)
  }

  const [showLoanProviderModal, setShowLoanProviderModal] = useState(false)

  const toggleLoanProviderModal = () => {
    setShowLoanProviderModal((prevState) => !prevState)
  }

  const [showTagLoanProviderModal, setShowTagLoanProviderModal] = useState(false)

  const toggleTagLoanProviderModal = () => {
    setShowTagLoanProviderModal((prevState) => !prevState)
    getUsers()
  }

  const [sortOrder, setSortOrder] = useState('DESC')
  const [allEmployees, setAllEmployees] = useState<boolean>(false)
  const [tradersCardNumberStatus, setTradersCardNumberStatus] = useState<boolean | undefined>()

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [pageNumber, setPage] = useState(1)
  const [customers, setCustomers] = useState([])
  const [loading, setLoading] = useState(false)
  const [searching, setSearching] = useState(false)
  const [searchReturnResult, setSearchReturnResult] = useState(false)

  const [paginationData, setPaginationData] = useState<{
    pageNumber: number
    pageSize: number
    total: number
  }>({
    pageNumber: 1,
    pageSize: 20,
    total: 1,
  })

  const [editData, setEditData] = useState<EmployeeType>()

  const [countries, setCountries] = useState<Array<countryType>>([])

  const getUsers = async () => {
    setLoading(true)
    setSearchReturnResult(false)
    await employeeService.index(pageNumber, sortOrder, undefined, undefined, allEmployees).then(
      (response) => {
        // console.log('employeeService', response?.data)
        setLoading(false)

        const dataSet = response?.data.data.dataset
        setCustomers(dataSet)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })

        dataSet.length > 0 && setSearchReturnResult(true)
      },
      (error: { response: { data: { error: string } } }) => {
        showAlert({
          message: error.response.data.error,
          show: true,
          title: 'Error',
          type: 'error',
        })

        setSearchReturnResult(false)
        setLoading(false)
      },
    )
  }

  useEffect(() => {
    getUsers()
  }, [pageNumber, sortOrder, allEmployees])

  // useEffect(() => {
  //   getUsers()
  // }, [tradersCardNumberStatus])

  const [selectedFields, setSelectedFields] = useState<string[]>([])

  const fieldsToAdd = [
    'employeeId',
    'lastName',
    'firstName',
    'msisdn',
    'emailAddress',
    'employmentStatus',
    'role',
    'department',
    'jobTitle',
    'employmentDate',
    'terminationDate',
  ]

  const toggleField = (field: string) => {
    setSelectedFields((prev) =>
      prev.includes(field) ? prev.filter((f) => f !== field) : [...prev, field],
    )
  }

  const handleExport = async () => {
    if (!selectedFields.length) {
      Swal.hideLoading()
      Swal.fire({
        icon: 'warning',
        title: 'Oops!',
        text: 'Please select at least one field',
        showConfirmButton: false,
        timer: 3000,
      })
      return
    }

    try {
      const res = await exportService.index()
      const csvString = res.data as string
      const parsed = Papa.parse<Record<string, string>>(csvString, {
        header: true,
        skipEmptyLines: true,
      })

      const exportCsv = CsvDownloader(
        parsed.data,
        selectedFields as (keyof (typeof parsed.data)[0])[],
        'tradegrid-employees.csv',
      )
      exportCsv()
    } catch (error: any) {
      // console.error('Error fetching CSV:', error)
      Swal.hideLoading()
      Swal.fire({
        icon: 'warning',
        title: 'Oops!',
        text: error.response.data.error || 'Something went wrong',
        showConfirmButton: false,
        timer: 3000,
      })
    }
  }

  const handleSearch = async (searchTerm: string) => {
    // If a search operation is already in progress, return early
    if (searching) {
      // return;
    }

    // Set the searching flag to true to indicate that a search is starting
    setSearching(true)
    setSearchReturnResult(false)

    // Perform search operation using the searchTerm
    console.log('Searching for:', searchTerm)
    const searchTermRes = checkSearchInputType(searchTerm)

    let endpoint = ''
    if (searchTermRes === 'Email') {
      endpoint = `emailAddress=${encodeURIComponent(searchTerm)}`
    } else if (searchTermRes === 'PhoneNumber') {
      endpoint = `msisdn=${encodeURIComponent(searchTerm)}`
    } else if (searchTermRes === 'AlphaNumeric') {
      endpoint = `id=${encodeURIComponent(searchTerm)}`
    } else if (searchTermRes === 'Numeric') {
      endpoint = `employeeId=${encodeURIComponent(searchTerm)}`
    }

    if (endpoint === '') {
      setLoading(false)
      setSearching(false)
      getUsers()
      return
    }

    setLoading(true)
    await employeeService.searchCustomer(endpoint, pageNumber, sortOrder).then(
      (response: {
        data: {
          data: {
            dataset: React.SetStateAction<never[]>
            pageNumber: number
            pageSize: number
            total: number
          }
        }
      }) => {
        setLoading(false)
        setSearching(false)

        const dataSet = response?.data.data.dataset

        setCustomers(dataSet)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })

        dataSet.length > 0 && setSearchReturnResult(true)
      },
      (error: { response: { data: { error: string } } }) => {
        setCustomers([])

        setTimeout(() => {
          setLoading(false)
          setSearching(false)
          if (searchTerm.length < 9) {
            getUsers()
          }
        }, 3000)

        setLoading(false)
        setSearchReturnResult(false)

        // showAlert({message: error.response.data.error, show:true, title: 'Error', type: 'error'})
        Logger('response error', error.response)
      },
    )
  }

  // get locations
  const getLocations = async () => {
    await locationService.index().then(
      (response) => {
        setCountries(response.data.data)
      },
      (error) => {
        console.log(error)
      },
    )
  }

  // useEffect(() => {
  //   getLocations()
  // }, [])

  const navigate = useNavigate()

  const [searchOptionRequest, setSearchOptionRequest] = useState(false)

  const searchRequest = async (data: {
    firstName: string | undefined
    lastName: string | undefined
  }) => {
    setSearchOptionRequest(true)
    setSearchReturnResult(false)
    await employeeService.searchCustomerName(data.firstName, data.lastName, 1, sortOrder).then(
      (response) => {
        setSearchOptionRequest(false)

        const dataSet = response?.data.data.dataset
        setCustomers(dataSet)

        setPaginationData({
          pageNumber: response?.data.data.pageNumber,
          pageSize: response?.data.data.pageSize,
          total: response?.data.data.total,
        })

        setSearchReturnResult(true)
      },
      (error: { response: { data: { error: string } } }) => {
        setSearchOptionRequest(false)
        console.log(error)
      },
    )
  }

  const cancelSearch = () => {
    getUsers()
  }

  const approveUpdate = async (employeeId: string) => {
    await employeeService.approveProfileUpdate(employeeId).then(
      () => {
        getUsers()
        Swal.fire({
          icon: 'success',
          title: 'Done!',
          text: 'Update approved successfully',
          showConfirmButton: false,
          timer: 3000,
        })
        Swal.hideLoading()
      },
      (error: { response: { data: { error: string } } }) => {
        Swal.hideLoading()
        console.log('leaveService', error)
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: error.response.data.error,
          showConfirmButton: false,
          timer: 3000,
        })
      },
    )
  }

  const handleOffBoarding = async (id: string) => {
    try {
      setLoading(true)
      const res = await employeeService.triggerExitForm(id)
      // console.log(res)
      if (res.data.status === true) {
        Swal.fire({
          icon: 'success',
          title: 'Done!',
          text: `Off-boarding form successfully issued to ${user?.firstName} ${user?.lastName}`,
          showConfirmButton: false,
          timer: 3000,
        })
        toggleOffBoardingModal()
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: 'Something went wrong',
          showConfirmButton: false,
          timer: 3000,
        })
      }
      Swal.hideLoading()
    } catch (error: any) {
      Swal.hideLoading()
      // console.log('off-boarding error', error)
      Swal.fire({
        icon: 'warning',
        title: 'Oops!',
        text: error.response.data.error,
        showConfirmButton: false,
        timer: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  const handleTermination = async (id: string) => {
    try {
      setLoading(true)
      const res = await employeeService.terminateEmployee(id)
      console.log(res)
      if (res.data.status === true) {
        Swal.fire({
          icon: 'success',
          title: 'Done!',
          text: `${user?.firstName} ${user?.lastName} employment has been terminated`,
          showConfirmButton: false,
          timer: 3000,
        })
        toggleTerminationModal()
      } else {
        Swal.fire({
          icon: 'warning',
          title: 'Oops!',
          text: 'Something went wrong',
          showConfirmButton: false,
          timer: 3000,
        })
      }
      Swal.hideLoading()
    } catch (error: any) {
      Swal.hideLoading()
      // console.log('off-boarding error', error)
      Swal.fire({
        icon: 'warning',
        title: 'Oops!',
        text: error.response.data.error,
        showConfirmButton: false,
        timer: 3000,
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className='Users'>
      <div className='container mt-4'>
        <div className='container'>
          <div className='card border-0'>
            <div className='card-header border-0 px-0'>
              <div className='row'>
                <div className='col-6 col-md-6 my-auto'>
                  <div className='title'>{paginationData.total} total employees</div>
                </div>
                <div className='col-12 col-sm-6 text-sm-end d-flex justify-content-end'>
                  <button className='btn btn-add-company' onClick={toggleModal}>
                    <PlusSignWhiteSvg />
                    Add New Employee
                  </button>

                  <div className='dropdown'>
                    <button
                      className='dropdown-item btn btn-export dropdown-toggle ms-2'
                      type='button'
                      id='dropdownMenuButton'
                      data-bs-toggle='dropdown'
                      aria-expanded='false'
                    >
                      <ExportSvg className='me-2' />
                      Export Users
                    </button>

                    {/* Dropdown content */}
                    <ul
                      className='dropdown-menu dropdown-menu-end export-dropdown border-0 shadow p-3 m-3'
                      aria-labelledby='dropdownMenuButton'
                    >
                      <p className='fw-bold mb-2 text-center text-capitalize'>
                        Select fields to export
                      </p>

                      {fieldsToAdd.map((field) => (
                        <label key={field} className='d-block mb-1'>
                          <input
                            type='checkbox'
                            checked={selectedFields.includes(field)}
                            onChange={() => toggleField(field)}
                            className='me-2'
                          />
                          {field}
                        </label>
                      ))}
                      <hr />
                      <button
                        onClick={handleExport}
                        className='dropdown-item btn-export btn-request dropdown-toggle text-white'
                      >
                        {/* <ExportSvg className='' /> */}
                        Export as .csv
                      </button>
                    </ul>
                  </div>
                </div>
              </div>

              <div className='row mt-2'>
                <div className='col-12 col-md-10'>
                  <SearchInput
                    onSearch={handleSearch}
                    searchType='user'
                    placeholder={'Search email, phone or user ID'}
                    searchRequest={searchRequest}
                    searchOptionRequest={searchOptionRequest}
                    searchReturnResult={searchReturnResult}
                    cancelSearch={cancelSearch}
                  ></SearchInput>
                </div>
                <div className='col-6 col-md-2 dropdown'>
                  <button
                    className='btn btn-filter dropdown-toggle'
                    data-bs-toggle='dropdown'
                    aria-expanded='false'
                  >
                    <FilterSvg />
                    Filters
                  </button>
                  <div className='dropdown-menu dropdown-menu-end border-0 shadow filter-dropdown'>
                    <div className='dropdown-item'>
                      <form action=''>
                        <div className='form-group'>
                          <label htmlFor=''>Sort List</label>
                          <select
                            id=''
                            className='form-control'
                            onChange={(e) => setSortOrder(e.target.value)}
                          >
                            <option value='DESC'>Descending Order</option>
                            <option value='ASC'>Ascending Order</option>
                          </select>
                        </div>

                        <div className='row mt-3'>
                          <div className='col-6 col-md-6'>
                            <button
                              type='button'
                              className='btn btn-reset'
                              onClick={() => setSortOrder('DESC')}
                            >
                              Reset
                            </button>
                          </div>
                          <div className='col-6 col-md-6 text-end'>
                            <button type='button' className='btn btn-filter-toggle'>
                              Filter
                            </button>
                          </div>
                        </div>
                        <div className='form-group mt-2'>
                          <label htmlFor=''>Include Exited Employees</label>
                          <select
                            id=''
                            className='form-control'
                            onChange={() => setAllEmployees((prev) => !prev)}
                          >
                            <option value='false'>No</option>
                            <option value='true'>Yes</option>
                          </select>
                        </div>

                        {/* <div className='row mt-3'>
                          <div className='col-md-6'>
                            <button
                              type='button'
                              className='btn btn-reset'
                              onClick={() => setSortOrder('DESC')}
                            >
                              Reset
                            </button>
                          </div>
                          <div className='col-md-6 text-end'>
                            <button type='button' className='btn btn-filter'>
                              Filter
                            </button>
                          </div>
                        </div> */}
                      </form>
                    </div>
                  </div>
                </div>
                {/* <div className="col-6 col-md-2">
                  <button className="btn btn-export">
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 11V17L11 15"
                        stroke="#868484"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M9 17L7 15"
                        stroke="#868484"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22 10V15C22 20 20 22 15 22H9C4 22 2 20 2 15V9C2 4 4 2 9 2H14"
                        stroke="#868484"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M22 10H18C15 10 14 9 14 6V2L22 10Z"
                        stroke="#868484"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>{" "}
                    Export
                  </button>
                </div> */}
              </div>
            </div>
            <div className='card-body'>
              <div className='table-responsive'>
                <table className='table'>
                  <thead>
                    <tr>
                      <td>ID</td>
                      <td>Photo</td>
                      <td>Fullname</td>
                      <td>Email</td>
                      <td>Phone Number</td>
                      {/* <td>Role</td> */}
                      <td>Status</td>
                      <td>Update Status</td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    {customers.length > 0 &&
                      customers.map((data: EmployeeSingleType, index: Key) => (
                        <tr key={index}>
                          <td
                            onClick={() => {
                              navigate(`/admin/user/${data.id}`)
                            }}
                            className='accountIdCol'
                          >
                            {TableSerialNumber(
                              pageNumber,
                              paginationData.pageSize,
                              parseInt(index.toString()),
                            )}
                          </td>
                          <td>
                            <ImageSrc
                              src={data.photo?.url}
                              alt={''}
                              title={''}
                              width={'profile-image'}
                            ></ImageSrc>
                          </td>
                          <td
                            onClick={() => {
                              navigate(`/admin/user/${data.id}`)
                            }}
                          >
                            {data.firstName} {data.lastName}
                          </td>
                          <td>{data.emailAddress}</td>
                          <td>
                            {data.msisdn ===
                            'Qui inventore necessitatibus natus provident eveniet soluta corrupti.'
                              ? '00000000000'
                              : data.msisdn}
                          </td>
                          {/* <td>{data.role}</td> */}
                          <td>
                            {data.employmentStatus === 'ACTIVE' ? (
                              <span className='status'>active</span>
                            ) : ['ON_OFFBOARDING', 'COMPLETED_OFFBOARDING', 'TERMINATED'].includes(
                                data.employmentStatus,
                              ) ? (
                              <span className='in-active'>inactive</span>
                            ) : (
                              <span className='status'>{data.employmentStatus.toLowerCase()}</span>
                            )}
                          </td>
                          <td>
                            {data.isProfileUpdateApproved === true ? (
                              <span className='status'>Approved</span>
                            ) : (
                              <span className='status pending'>Pending</span>
                            )}
                          </td>

                          <td className='dropdown option-dropdown'>
                            <Link to={`/admin/user/${data.id}`}>
                              <button className='btn btn-sm p-0 border-0'>
                                <svg
                                  width='18'
                                  height='18'
                                  viewBox='0 0 18 18'
                                  fill='none'
                                  xmlns='http://www.w3.org/2000/svg'
                                >
                                  <path
                                    d='M8.99945 12.2474C7.20695 12.2474 5.75195 10.7924 5.75195 8.99994C5.75195 7.20744 7.20695 5.75244 8.99945 5.75244C10.792 5.75244 12.247 7.20744 12.247 8.99994C12.247 10.7924 10.792 12.2474 8.99945 12.2474ZM8.99945 6.87744C7.82945 6.87744 6.87695 7.82994 6.87695 8.99994C6.87695 10.1699 7.82945 11.1224 8.99945 11.1224C10.1695 11.1224 11.122 10.1699 11.122 8.99994C11.122 7.82994 10.1695 6.87744 8.99945 6.87744Z'
                                    fill='#82858A'
                                  />
                                  <path
                                    d='M9.00055 15.7651C6.18055 15.7651 3.51805 14.1151 1.68805 11.2501C0.893047 10.0126 0.893047 7.99511 1.68805 6.75011C3.52555 3.88511 6.18805 2.23511 9.00055 2.23511C11.813 2.23511 14.4755 3.88511 16.3055 6.75011C17.1005 7.98761 17.1005 10.0051 16.3055 11.2501C14.4755 14.1151 11.813 15.7651 9.00055 15.7651ZM9.00055 3.36011C6.57805 3.36011 4.26055 4.81511 2.64055 7.35761C2.07805 8.23511 2.07805 9.76511 2.64055 10.6426C4.26055 13.1851 6.57805 14.6401 9.00055 14.6401C11.423 14.6401 13.7405 13.1851 15.3605 10.6426C15.923 9.76511 15.923 8.23511 15.3605 7.35761C13.7405 4.81511 11.423 3.36011 9.00055 3.36011Z'
                                    fill='#82858A'
                                  />
                                </svg>
                              </button>
                            </Link>

                            <button
                              className='btn border-0 dropdown-toggle'
                              data-bs-toggle='dropdown'
                              aria-expanded='false'
                              data-bs-popper-config='{"strategy":"fixed"}'
                            >
                              <svg
                                width='18'
                                height='18'
                                viewBox='0 0 18 18'
                                fill='none'
                                xmlns='http://www.w3.org/2000/svg'
                              >
                                <path
                                  d='M7.49991 8.4705C7.49991 7.72933 8.0955 7.14697 8.82344 7.14697C9.55138 7.14697 10.147 7.74256 10.147 8.4705C10.147 9.19844 9.55138 9.79403 8.82344 9.79403C8.0955 9.79403 7.49991 9.21168 7.49991 8.4705Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 14.1175C7.49991 13.3763 8.0955 12.7939 8.82344 12.7939C9.55138 12.7939 10.147 13.3895 10.147 14.1175C10.147 14.8454 9.55138 15.441 8.82344 15.441C8.0955 15.441 7.49991 14.8587 7.49991 14.1175Z'
                                  fill='#707070'
                                />
                                <path
                                  d='M7.49991 2.82353C7.49991 2.08235 8.0955 1.5 8.82344 1.5C9.55138 1.5 10.147 2.09559 10.147 2.82353C10.147 3.55147 9.55138 4.14706 8.82344 4.14706C8.0955 4.14706 7.49991 3.56471 7.49991 2.82353Z'
                                  fill='#707070'
                                />
                              </svg>
                            </button>

                            <ul className='dropdown-menu dropdown-menu-end option-dropdown border-0 shadow'>
                              <li className='dropdown-item'>
                                <Link to={`/admin/user/${data.id}`} className='w-100 d-block'>
                                  View User
                                </Link>
                              </li>

                              <li className='dropdown-item'>
                                <Link
                                  to={`/admin/admin-kpi-manager/${data.id}`}
                                  className='w-100 d-block'
                                >
                                  Manage KPI
                                </Link>
                              </li>

                              {data.isProfileUpdateApproved === false &&
                                data.employmentStatus === 'ACTIVE' && (
                                  <li
                                    className='dropdown-item text-danger'
                                    onClick={() => approveUpdate(data.id)}
                                  >
                                    Approve update
                                  </li>
                                )}

                              <li className='dropdown-item'>
                                <Link
                                  to={`/admin/payslip-admin/payslip-user-admin-history/${data.id}`}
                                  className='w-100 d-block'
                                >
                                  Payslip History
                                </Link>
                              </li>

                              <li
                                className='dropdown-item text-danger'
                                onClick={() => {
                                  setUser(data)
                                  setShowOffBoardingModal(true)
                                }}
                              >
                                {/* <Link to={''} className='w-100 d-block'> */}
                                Exit Form
                                {/* </Link> */}
                              </li>
                              {['ON_OFFBOARDING', 'COMPLETED_OFFBOARDING'].includes(
                                data.employmentStatus,
                              ) ? (
                                <li
                                  className='dropdown-item text-danger'
                                  onClick={() => {
                                    setUser(data)
                                    setShowTerminationModal(true)
                                  }}
                                >
                                  Terminate User
                                </li>
                              ) : (
                                <p className='d-none'></p>
                              )}
                            </ul>
                          </td>
                        </tr>
                      ))}
                    {loading === false && customers.length === 0 && (
                      <tr>
                        <td colSpan={8} className='text-center'>
                          No user found
                        </td>
                      </tr>
                    )}
                    {loading === true && (
                      <tr>
                        <td colSpan={8} className='text-center'>
                          <HorizontalLoader></HorizontalLoader>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              {paginationData.total >= paginationData.pageSize && (
                <div className='pagination w-100 d-flex justify-content-center'>
                  {paginationData.total && (
                    <Pagination
                      className='pagination-bar ps-0'
                      currentPage={Number(paginationData.pageNumber)}
                      totalCount={paginationData.total}
                      pageSize={paginationData.pageSize}
                      onPageChange={(page: React.SetStateAction<number>) => setPage(page)}
                    />
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <ModalWrapper showModal={showModal} closeModal={toggleModal} title='Add New User'>
        <AddUser toggleModal={toggleModal}></AddUser>
      </ModalWrapper>

      <ModalWrapper
        showModal={showOffBoardingModal}
        closeModal={toggleOffBoardingModal}
        title='Employee Off Boarding'
      >
        <p>
          You&apos;re about to trigger the off-boarding form for{' '}
          <strong>
            {user?.firstName} {user?.lastName}
          </strong>
          . Would you like to continue?
        </p>

        {/* confirm button */}
        <div className='d-flex'>
          <button
            className='btn btn-default mt-3 ms-auto me-3'
            onClick={() => handleOffBoarding(user?.id)}
          >
            Yes {loading && <span className='spinner-border spinner-border-sm ms-2'></span>}
          </button>
        </div>
      </ModalWrapper>

      <ModalWrapper
        showModal={showTerminationModal}
        closeModal={toggleTerminationModal}
        title='Employment Termination'
      >
        <p>
          You&apos;re about to terminate the employment of{' '}
          <strong>
            {user?.firstName} {user?.lastName}
          </strong>
          . Would you like to continue?
        </p>

        {/* confirm button */}
        <div className='d-flex'>
          <button
            className='btn btn-default mt-3 ms-auto me-3'
            onClick={() => handleTermination(user?.id)}
          >
            Yes {loading && <span className='spinner-border spinner-border-sm ms-2'></span>}
          </button>
        </div>
      </ModalWrapper>

      <ModalWrapper
        showModal={showEditModal}
        closeModal={toggleEditModal}
        title='Edit User Account Plan'
      >
        <EditUserPlan
          toggleEditModal={toggleEditModal}
          countries={countries}
          editData={editData}
        ></EditUserPlan>
      </ModalWrapper>
    </div>
  )
}

export default Users
